module.exports = __webpack_public_path__ + "media/images/favicons/16-a58de9f913f98a0bb970901716ad5bae.png";